import { track } from '@leagueplatform/analytics';
import { Button } from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';
import React from 'react';

interface CloseButtonProps {
  onClose: Function;
}

export const CloseButton = ({ onClose }: CloseButtonProps) => {
  const { formatMessage } = useIntl();

  function closeToast() {
    track('rewards.button_clicked.progress_toast.dismiss');

    onClose();
  }

  return (
    <Button
      quiet
      priority="tertiary"
      icon="tinyClose"
      onClick={() => closeToast()}
      css={{ marginInlineStart: '$half', height: '$two' }}
      size="small"
      hideLabel
    >
      {formatMessage({ id: 'DISMISS_TOAST' })}
    </Button>
  );
};
